import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import Preloader from "./Preloader";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import usePageTitle from "../../hooks/usePageTitle";
import { Accordion, Card } from "react-bootstrap";

const LoginHome = (props) => {
  const authContext = useContext(AuthContext);
  const { loading } = authContext;
  const alertContext = useContext(AlertContext);
  const { clearAlerts } = alertContext;
  const configContext = useContext(ConfigContext);
  // const { supportLink } = props;
  const { loaded, getConfigValue } = configContext;
  //eslint-disable-next-line
  const [pageTitle, setPageTitle] = useState(props.appTitle + "-" + "Home");
  useEffect(() => {
    if (loaded) {
      const msgDisplayTime =
        getConfigValue(
          "generalConfig",
          "Message_Display_Duration",
          "App_Config"
        ) * 1000;
      setTimeout(function () {
        clearAlerts();
      }, msgDisplayTime);
    }
    //eslint-disable-next-line
  }, [loaded]);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "",
  });

  const [activeId, setActiveId] = useState("0");

  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  return (
    <Fragment>
      <main className="main-content__login">
        {/* <div className="main-content__login__cardDeck">
          <div
            className="main-content__login__cardDeck__imageCard"
            role="region"
          >
            <div className="main-content__login__cardDeck__imageCard__closedIcon">
              <i className="fas fa-user-tie fa-3x circle-icon"></i>
            </div>
            <div className="main-content__login__cardDeck__imageCard__title">
              Not a Registered User?
            </div>
            <div>
              <Link
                className="main-content__login__cardDeck__imageCard__link"
                to="/unreg-recharge"
                role="link"
              >
                Click here reload your Metro Q Card®
              </Link>
            </div>
          </div>
          <div
            className="main-content__login__cardDeck__imageCard"
            role="region"
          >
            <div className="main-content__login__cardDeck__imageCard__closedIcon">
              <i className="far fa-credit-card fa-3x circle-icon"></i>
            </div>
            <div className="main-content__login__cardDeck__imageCard__title">
              Is Your Card / Pass Expiring?
            </div>
            <div>
              <a
                className="main-content__login__cardDeck__imageCard__link"
                href="https://www.ridemetro.org/Pages/FareMyQ.aspx"
              >
                Click here to find out when your Metro fare Card expires
              </a>
            </div>
          </div>
        </div> */}
        {loading && <Preloader />}
        <div className="main-content__login__noticeCard" role="region">
          <h2 className="main-content__login__noticeCard__title">
            COMMON QUESTIONS
          </h2>
          <Accordion defaultActiveKey="0">
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                onClick={() => toggleActive("0")}
                className={
                  activeId === "0" ? "card-header__selected" : "card-header"
                }
              >
                <h2>
                  <button
                    className="card-header__accordian__toggle"
                    aria-controls="question1"
                    id="accordion1"
                    aria-expanded={activeId === "0" ? true : false}
                  >
                    What can I do on this page?
                  </button>
                </h2>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey="0"
                id="question1"
                role="region"
                aria-labelledby="accordion1"
              >
                <Card.Body>
                  <p>
                    On this page, you can reload fare cards that have previously
                    been
                    <span className="bold"> registered</span> with METRO.
                  </p>
                  <p>
                    When you login, make sure you use the Email Address you
                    provided at the time you registered your card.
                  </p>
                  <p>
                    If you need to reload an
                    <span className="bold"> unregistered card</span>,{" "}
                    <Link to="/unreg-recharge" role="link">
                      visit this page
                    </Link>
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="1"
                onClick={() => toggleActive("1")}
                className={
                  activeId === "1" ? "card-header__selected" : "card-header"
                }
              >
                <h2>
                  <button
                    className="card-header__accordian__toggle"
                    aria-controls="question2"
                    id="accordion2"
                    aria-expanded={activeId === "1" ? true : false}
                  >
                    What payment methods can I use to reload my fare card?
                  </button>
                </h2>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey="1"
                id="question2"
                role="region"
                aria-labelledby="accordion2"
              >
                <Card.Body>
                  <p>
                    You can use a credit or debit card – or a transit benefits
                    card that may have been issued to you by another
                    organization.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="2"
                onClick={() => toggleActive("2")}
                className={
                  activeId === "2" ? "card-header__selected" : "card-header"
                }
              >
                <h2>
                  <button
                    className="card-header__accordian__toggle"
                    aria-controls="question3"
                    id="accordion3"
                    aria-expanded={activeId === "2" ? true : false}
                  >
                    How soon will the funds I add to my card be available?
                  </button>
                </h2>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey="2"
                id="question3"
                role="region"
                aria-labelledby="accordion3"
              >
                <Card.Body>
                  <p>
                    When you reload your METRO fare card online, the amount
                    added may not be available on your card for 24 to 48 hours.
                  </p>
                  <p>
                    It won’t appear as part of your balance until the next time
                    you use your card to pay a fare.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="3"
                onClick={() => toggleActive("3")}
                className={
                  activeId === "3" ? "card-header__selected" : "card-header"
                }
              >
                <h2>
                  <button
                    className="card-header__accordian__toggle"
                    aria-controls="question4"
                    id="accordion4"
                    aria-expanded={activeId === "3" ? true : false}
                  >
                    I’m a first-time user or I don’t remember my password. How
                    do I get it ?
                  </button>
                </h2>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey="3"
                id="question4"
                role="region"
                aria-labelledby="accordion4"
              >
                <Card.Body>
                  <p>
                    To set up your initial password or reset your current
                    password,{" "}
                    <Link to="/forgot-password" role="link">
                      click here to visit our Reset Account Password page{" "}
                    </Link>
                    where you can provide us your email address and request a
                    new password link.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>

          <div className="main-content__login__noticeCard__text-block"></div>
          <div className="main-content__login__noticeCard__text-block"></div>
          <div className="main-content__login__noticeCard__text-block"></div>
        </div>
      </main>
    </Fragment>
  );
};

// LoginHome.propTypes = {
//   supportLink: PropTypes.string.isRequired,
// };

// LoginHome.defaultProps = {
//   supportLink: {
//     label: "Metro Home",
//     url: "https://www.ridemetro.org/Pages/FareMyQ.aspx",
//   },
// };

export default withRouter(LoginHome);
